module.exports = __webpack_public_path__ + "static/media/sl(2).a51d6de4.jpg";